import * as React from 'react'
import { PageHeader } from '@pushly/aqe/lib/components'
import { classnames } from '@halo/_utils/classnames'
import { observer } from 'mobx-react'
import { UserList } from '@halo/components/user-list/user-list'
import { noop } from '@pushly/aqe/lib/utils/noop'

export const USERS_ROUTE = '/users'

@observer
export class Users extends React.Component<any, any> {
    public render() {
        return (
            <div className={classnames('page', 'users')}>
                <div className={classnames('page-wrapper')}>
                    <PageHeader title="Users" onTitleSet={noop} />

                    <UserList options={{}} />
                </div>
            </div>
        )
    }
}
